import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  // like data
  state: {
    msalConfig: {
      auth: {
        clientId: "0b664ebc-0041-47b1-a3ef-610bf8872af4",
        authority: "https://login.microsoftonline.com/common"
      },
      cache: {
        cacheLocation: "localStorage"
      }
    },
    accessToken: ''
  },
  mutations: {
    setAccessToken (state, accessToken) {
      state.accessToken = accessToken
    }
  },
  // like methods
  actions: {

  },
  // like computed
  getters: {

  }
})



// WEBPACK FOOTER //
// ./src/store.js